import { createContext, useContext } from 'react';
import { MonthFieldRequest } from '@pxtra-client-lib-legacy/gen';

export interface CustomBenefitTableContextValue {
  benefitId: string;
  companyAmount: number;
  assignmentsStart: MonthFieldRequest;
  createAssignments: (params: {
    startAccountingPeriod: MonthFieldRequest;
    amount: number;
    employees: string[];
    resetToCompanyAmount?: boolean;
  }) => void;
  deleteAssignments: (params: { assignmentIds: string[]; all?: boolean }) => void;
  focusedEmployeeId: string | undefined;
  setFocusedEmployeeId: (id: string | undefined) => void;
}

const CustomBenefitTableContext = createContext<CustomBenefitTableContextValue | null>(null);

export const CustomBenefitTableProvider = CustomBenefitTableContext.Provider;

export function useCustomBenefitTableContext(): CustomBenefitTableContextValue {
  const context = useContext(CustomBenefitTableContext);
  if (!context) {
    throw new Error(
      'useCustomBenefitTableContext must be used within a CustomBenefitTableProvider'
    );
  }
  return context;
}
